export default __webpack_public_path__ + "static/media/3w.e0c0935b.svg";